export default __webpack_public_path__ + "static/media/cat.3bb15ed5.svg";